const questions = [
  {
    questionText: "Wat wil jij het allerliefst doen op je verjaardagsfeestje?",
    answerOptions: [
      {
        answerText: "Naar het klimbos",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "In een muziekband spelen",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "Iets wat iedereen die komt leuk vindt om te doen.",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText:
          "Zwemmen, vogelhuisje timmeren, lasergamen, cakejes versieren en….ik kan niet wachten!",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "Workshop robots bouwen",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText:
          "Maakt niet uit, als ik het maar zelf kan regelen, van de uitnodigingen tot de spelletjes",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "Wie is jouw held?",
    answerOptions: [
      {
        answerText: "De politie",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "Mijn favoriete vlogger",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "Mijn juf/ meester",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText: "Die goeie profvoetballer",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "De uitvinder van internet",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText: "De minister president",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "Mensen die mij goed kennen weten dat ik...",
    answerOptions: [
      {
        answerText: "heel veel durf",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "graag teken en knutsel",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "vaak anderen help",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText: "(bijna) altijd bezig ben",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "alles wil onderzoeken en ontdekken",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText: "heel precies ben",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "Ik ben trots op deze eigenschap",
    answerOptions: [
      {
        answerText: "Dapper",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "Fantasierijk",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "Vriendelijk",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText: "Energiek",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "Nieuwsgierig",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText: "Doorzetter",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "Dit doe ik met 100 euro",
    answerOptions: [
      {
        answerText: "Krasloten kopen",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText:
          "Daar koop ik een programma van om foto’s en filmpjes te bewerken",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "Ik geef een deel aan een goed doel",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText: "Ik koop nieuwe sneakers",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "Ik koop een telescoop",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText: "Ik zet het op mijn spaarrekening",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "Ik wil graag een dagje meelopen met een ...",
    answerOptions: [
      {
        answerText: "astronaut",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "ontwerper",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "dokter",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText: "gymleraar",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "uitvinder",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText: "directeur",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "Dit ben ik",
    answerOptions: [
      {
        answerText: "Ik doe graag iets nieuws",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "Ik heb heel veel ideeën",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "Ik heb het liefst anderen om me heen",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText: "Ik ben handig",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "Ik denk veel na",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText: "Ik krijg vaak iets voor elkaar",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "op vakantie ...",
    answerOptions: [
      {
        answerText: "wil ik bergbeklimmen en abseilen",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "Houd ik een fotoalbum en dagboek bij",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "zorg ik ervoor dat iedereen het leuk heeft",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText:
          "help ik meteen met de tent opzetten en duik daarna het water in",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "wil ik grotten en restanten van oude kastelen bekijken",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText:
          "zoek ik uit wat er te doen is in de buurt en overtuig anderen om mee te gaan",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "Dit een toepasselijke koosnaam voor mij",
    answerOptions: [
      {
        answerText: "Held",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "Crea-Bea",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "Schat",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText: "SnelleJelle",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "Professor",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText: "Baas",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "Het leukste op school vind ik ...",
    answerOptions: [
      {
        answerText: "de pauze",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "muziekles",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "biologie",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText: "gym",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "techniek",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText: "een spreekbeurt houden",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  },
  {
    questionText: "Mijn fiets en ik ...",
    answerOptions: [
      {
        answerText: "van een berg crossen",
        categoryCode: "A",
        categoryName: "avontuurlijk"
      },
      {
        answerText: "fiets versieren",
        categoryCode: "B",
        categoryName: "creatief"
      },
      {
        answerText: "fiets wassen",
        categoryCode: "C",
        categoryName: "verzorgend"
      },
      {
        answerText: "fiets repareren",
        categoryCode: "D",
        categoryName: "actief"
      },
      {
        answerText: "onderdelen vergelijken",
        categoryCode: "E",
        categoryName: "onderzoekend"
      },
      {
        answerText: "fiets verkopen",
        categoryCode: "F",
        categoryName: "ondernemend"
      }
    ]
  }
];

export default questions;
